var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.638672 0.398438)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9158",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.638672",
              y: "0.398438",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9158)" } }, [
        _c("path", {
          attrs: {
            d: "M46.6209 0.582031H1.13477V46.3975H46.6209V0.582031Z",
            fill: "#FF7DB9",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.6385 0.398438H0.638672V46.3984H46.6385V0.398438Z",
            fill: "#FF681C",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.6374 18.3516V46.3966H18.75C18.75 30.9082 31.2361 18.3516 46.6374 18.3516Z",
            fill: "#FF974A",
          },
        }),
        _c("path", {
          attrs: {
            d: "M32.9921 7.12891L0.638697 39.6655L-31.7148 7.12891H32.9921Z",
            fill: "#FF974A",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }